import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    region: [],
    NEW_REGION: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    Tsm_Name: [],
    Spm_Name: [],
  },
  submitted: 0,
};

const SalesSuccessCenterfilterSlice = createSlice({
  name: "salesSuccessfilter",
  initialState,
  reducers: {
    addFilters(state, action) {
      state.data = action.payload.data;
      state.submitted = action.payload.submitted;
      // state.fmsNav = action.payload.fmsNav;
    },
    applyFilters(state, action) {
      state.data = action.payload;
    },
    chgSubmitted(state, action) {
      state.submitted = action.payload;
    },
    resetFilters(state) {
      state.data = initialState.data;
      state.submitted = initialState.submitted;
    },
  },
});

export const { addFilters, applyFilters, chgSubmitted, resetFilters } =
  SalesSuccessCenterfilterSlice.actions;

export default SalesSuccessCenterfilterSlice.reducer;
